"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.archive = void 0;
exports.archive = {
    path: "M4.15833 2.5H15.8333C16.75 2.5 17.5 3.25 17.5 4.16667V15.8333C17.5 16.75 16.75 17.5 15.8333 17.5H4.15833C3.23333 17.5 2.5 16.75 2.5 15.8333V4.16667C2.5 3.25 3.23333 2.5 4.15833 2.5ZM11.2083 7.5H13.3333L10 10.8333L6.66667 7.5H8.79167V5H11.2083V7.5ZM15.8333 15.8333H4.16667V13.3333H7.13333C7.70833 14.325 8.775 15 10.0083 15C11.2417 15 12.3 14.325 12.8833 13.3333H15.8333V15.8333ZM11.675 11.6667H15.8333V4.16667H4.15833L4.16667 11.6667H8.34167C8.34167 12.5833 9.09167 13.3333 10.0083 13.3333C10.925 13.3333 11.675 12.5833 11.675 11.6667Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
